/**
 *
 * Global Nav (JS)
 *
 * @author Yusuke Manabe @ Space-Time Inc.
 * @author Takuto Yanagida @ Space-Time Inc.
 * @version 2020-10-19
 *
 */


(function() {

	const CLS_CURRENT       = 'current';
	const CLS_MENU_ANCESTOR = 'menu-ancestor';
	const CLS_PAGE_ANCESTOR = 'page-ancestor';

	const SEL_NAV_BAR      = '.site-global-nav-bar';
	const PX_OFFSET_SCROLL = 20;


	document.addEventListener('DOMContentLoaded', function() {
		scrollMenu(SEL_NAV_BAR, PX_OFFSET_SCROLL);
	});


	// -------------------------------------------------------------------------


	function scrollMenu(selBar, scrollOffset) {
		const mis = document.querySelectorAll(selBar + ' .menu > li');

		for (let i = 0; i < mis.length; i += 1) {
			if (mis[i].classList.contains(CLS_CURRENT) ||
				mis[i].classList.contains(CLS_MENU_ANCESTOR) ||
				mis[i].classList.contains(CLS_PAGE_ANCESTOR)) {
				doScroll(mis[i]);
			}
			mis[i].firstChild.addEventListener('click', () => { doScroll(mis[i]); });
		}
		function doScroll(curMi) {
			let m = curMi.parentElement;
			while (! m.classList.contains('scroll')) m = m.parentElement;
			if (! m) return;

			const right = curMi.offsetLeft + curMi.offsetWidth;
			if (m.offsetWidth < right) m.scrollLeft = curMi.offsetLeft - scrollOffset;
			if (curMi.offsetLeft < m.scrollLeft) m.scrollLeft = curMi.offsetLeft - scrollOffset;
		}
	}


}());
